module.exports = __webpack_public_path__ + "img/2.34648358.jpg";